<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E_%E7%B7%A8%E8%BC%AF_%E5%A7%94%E8%A8%97%E8%BD%89%E5%B8%B3%E4%BD%9C%E6%A5%AD -->
<!-- 新增_編輯_委託轉帳作業 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="coopEmtrustedTransfer"
                :id="id"
                labelPosition="top"
                formTitle="委託轉帳作業"
                :rules="rules"
                :recordToEdit="recordToEdit"
                ref="listForm"
                :formType="formType"
                @itemChange="handleItemChange"
                v-if="$route.meta.formKeepAlive"
            >
                <div slot="footer" v-if="id">
                    <el-button type="primary" @click="$refs.listForm.submitForm('recordToEdit')">儲存</el-button>
                    <el-button type="primary" @click="execTransfer">手動執行</el-button>
                    <el-button @click="$refs.listForm.back()">取消</el-button>
                </div>
            </ListForm>
            <router-view v-else></router-view>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "entrusted_transfer_edit",
    components: {
        ListForm
    },
    data() {
        return {
            id: this.$route.params.id === "new" ? 0 : this.$route.params.id,
            recordToEdit: {
                from: "備轉金提款"
            },
            formType: [
                {
                    label: "委託人帳號",
                    key: "sourceMemberId",
                    type: "chooseMember",
                    returnKey: "id",
                    require: true
                },
                {
                    label: "每月轉帳日",
                    key: "transferDateByMonth",
                    type: "input",
                    require: true
                },
                {
                    label: "來源項目",
                    key: "from",
                    type: "input",
                    disabled: true
                },
                {
                    label: "目的帳號",
                    key: "targetMemberId",
                    type: "chooseMember",
                    returnKey: "id",
                    require: true
                },
                {
                    label: "目的項目",
                    key: "targetItem",
                    type: "select",
                    options: [],
                    require: true
                },
                {
                    label: "自選會計科目",
                    key: "targetAccountTitleId",
                    type: "select",
                    options: [],
                    filterable: true,
                    vif: false,
                    post: true,
                    require: true
                },
                {
                    label: "借據",
                    key: "loanIouNumber",
                    type: "select",
                    options: [],
                    vif: false,
                    post: true,
                    require: true
                },
                {
                    label: "金額",
                    key: "targetAmount",
                    type: "input",
                    addcomma: true,
                    require: true,
                    // 借據還款(COOP_CASH_ITEM_LOAN=4)的金額由試算計算，不需手動填；其餘目的項目才必填金額
                    validateEmptyFunc: item =>
                        this.recordToEdit.targetItem != 4 && this.recordToEdit[item.key] <= 0
                },
                {
                    label: "委託日期",
                    key: "emtrustedDate",
                    type: "date"
                },
                {
                    label: "開始轉帳年(民國年)",
                    key: "startYear",
                    type: "input",
                    require: this.$route.params.id === "new",
                    vshow: this.$route.params.id === "new"
                },
                {
                    label: "開始轉帳月",
                    key: "startMonth",
                    type: "input",
                    require: this.$route.params.id === "new",
                    vshow: this.$route.params.id === "new"
                },
                {
                    label: "最近轉帳日",
                    key: "lastTransferDate",
                    type: "date",
                    disabled: true
                }
            ],
            rules: {}
        };
    },
    created() {
        this.getData();
    },
    watch: {
        recordToEdit: {
            handler(newVal) {
                // 以 key 取欄位，避免 formType 順序調整後索引取錯
                const accountTitleField = this.getField("targetAccountTitleId");
                const iouField = this.getField("loanIouNumber");
                
                // 目的項目選擇其他時，顯示自選會計科目欄位
                if (newVal.targetItem == 5) {
                    accountTitleField.vif = true;
                    accountTitleField.post = true;
                } else {
                    accountTitleField.vif = false;
                    accountTitleField.post = false;
                }

                // 目的項目選擇還款時，顯示借據欄位，隱藏金額欄位
                if (newVal.targetItem == 4) {
                    this.getMemberIouList();
                    iouField.vif = true;
                    iouField.post = true;
                } else {
                    iouField.vif = false;
                    iouField.post = false;
                }
            },
            deep: true
        },
        $route(to, from) {
            if (
                to.name == "entrusted_transfer_edit" &&
                this.$route.params.id !== "new"
            ) {
                this.getData();
            }
        }
    },
    methods: {
        /**
         * 以 key 取得 formType 欄位設定，避免用數字索引在欄位順序調整後取錯
         * @param {string} key formType 欄位的 key
         * @returns {Object|undefined} 對應的 formType 欄位設定
         */
        getField(key) {
            return this.formType.find(item => item.key == key);
        },
        /**
         * ListForm 於 chooseMember 選取後會 emit itemChange(id, row, item)。
         * 目的帳號變更時，借據清單需依新目的帳號重抓（委託人帳號變更不需要）。
         * @param {number} id 選取的社員 id
         * @param {Object} row 選取的社員資料列
         * @param {Object} item 觸發變更的 formType 欄位設定
         */
        handleItemChange(id, row, item) {
            if (item && item.key === "targetMemberId" && this.recordToEdit.targetItem == 4) {
                this.recordToEdit.loanIouNumber = "";  // 清掉舊會員的借據選擇
                this.getMemberIouList();
            }
        },
        /**
         * 取得委託轉帳單資料，並填入目的項目、自選會計科目下拉選項
         */
        async getData() {
            const url = API.coopEmtrustedTransfer + `?id=${this.id}`;
            try {
                const json = await this.mAxiosGet(url);

                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                // 目的項目
                this.getField("targetItem").options = json.resultData.enumData.transferItemsEnum;
                // 自選會計科目
                this.getField("targetAccountTitleId").options = json.resultData.enumData.accountTitles.map(
                    val => {
                        return {
                            label: `${val.code} ${val.name}`,
                            value: val.id
                        };
                    }
                );
            } catch (error) {
                console.error("Failed to get data in getData.", error);
            }
        },
        /**
         * 手動執行委託轉帳，呼叫後端 exec 開立傳票。
         * 後端 ExecTransfer 失敗時會攔截例外、以 success=0 正常回傳（HTTP 200），
         * 需自行判斷 success 並顯示後端寫入的錯誤訊息。
         */
        async execTransfer() {
            const url = API.coopEmtrustedTransfer + `?action=exec`;
            const form = new FormData();
            form.append("id", this.recordToEdit.id);
            try {
                const json = await this.mAxiosPost(url, form);

                // success = 0 代表後端已 rollback 並寫入失敗紀錄，顯示錯誤訊息
                const resultData = json.resultData;
                if (resultData && resultData.success !== 1) {
                    this.$message.error(resultData.error || "委託轉帳執行失敗");
                } else {
                    this.showAjaxSuccessMsg();
                }
            } catch (error) {
                console.error("Exec operation failed in execTransfer.", error);
            }
        },
        /**
         * 依目的帳號取得該社員的借據清單，填入借據欄位選項
         */
        async getMemberIouList() {
            const targetMemberId = this.recordToEdit.targetMemberId;
            if (!targetMemberId) return false;

            const url = API.coopLoanIou + `?action=getListByMember&memberId=${targetMemberId}`;
            try {
                const json = await this.mAxiosGet(url);

                this.recordToEdit = Object.assign(
                    this.recordToEdit,
                    json.resultData.data
                );
                this.getField("loanIouNumber").options = json.resultData.map(val => {
                    return {
                        label: `${val.iouNumber}`,
                        value: val.iouNumber
                    };
                });
            } catch (error) {
                console.error("Failed to get data in getMemberIouList.", error);
            }
        }
    }
};
</script>